import { trigger, state, style, transition, animate } from '@angular/animations';
import { CdkDialogContainer, DialogModule } from '@angular/cdk/dialog';
import { Component } from '@angular/core';

@Component({
    selector: 'dialog-container',
    styles: [
        `
      :host {
        min-width: clamp(min(10vw, 20rem), 400px, max(90vw, 55rem));
        max-height: 100dvh;
        z-index: 99999;
      }
    `,
    ],
    template: '<ng-template cdkPortalOutlet></ng-template>',
    imports: [DialogModule],
    animations: [
        trigger('dialogAnimation', [
            state('void', style({
                opacity: 0,
                transform: 'scale(0.8)',
            })),
            state('*', style({
                opacity: 1,
                transform: 'scale(1)',
            })),
            transition('void => *', [
                animate('300ms ease-out')
            ]),
            transition('* => void', [
                animate('200ms ease-in')
            ]),
        ]),
    ],
    host: {
        '[@dialogAnimation]': '',
        'class': 'bg-white rounded-lg shadow-lg p-2 transition-all duration-1000 ease-[cubic-bezier(0.68,-0.55,0.27,1.55)]'
    }
})
export class CustomDialogContainer extends CdkDialogContainer {}
